
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,

} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getContractStatsSeason} from "../../Contract/ContractClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractStats} from "./contractStatsSlice";
import {changeContractStatsControls} from "./contractStatsControlsSlice";
import {StatsMenu} from "./StatsMenu";


// main function
export default function SeasonContractStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [seasonContractStats, setSeasonContractStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorGridDisplay = useSelector((state) => state.contractStatsControlsSlc.value.gridDisplay);
    const selectorSeriesId = useSelector((state) => state.contractStatsSlc.value.seriesId);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchSeasonContractStats = () =>
        getContractStatsSeason(selectorSeriesId)

            .then(data => {
                console.log(data);
                setSeasonContractStats(data);
            })
    useEffect(() => {
        fetchSeasonContractStats();
    }, []);

    useEffect(() => {
        fetchSeasonContractStats();
        dispatchData(changeContractStatsControls({gridRefresh: false}));
    }, [useSelector((state) => state.contractStatsControlsSlc.value.gridRefresh)===true]);
    // ****************** END FETCH ****************************


    const renderSeasonContractStats = seasonContractStats => {
        if (seasonContractStats.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectSeriesContractStatId,selectSeriesContractStatMcode, selectSeriesContractStatName, selectSeriesContractStatDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        // dispatchData(changeSeriesContractStat({id: selectSeriesContractStatId, mcode: selectSeriesContractStatMcode, name: selectSeriesContractStatName, description: selectSeriesContractStatDescription }));
    }

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (seasonContractStats) => {

        console.log('Stats data from clicked row');
        console.log(seasonContractStats);
        dispatchData(changeContractStats({seriesId: seasonContractStats.seriesId, seasonId: seasonContractStats.seasonId,
            seriesTitle: seasonContractStats.seriesTitle,  seasonName: seasonContractStats.seasonName
            , productId: null, episodeName: null, photoStartDate: null}));
        dispatchData(changeContractStatsControls({gridDisplay: selectorGridDisplay === "SeasonFullScreen" ? "EpisodeFullScreen" : "EpisodeRightPanel"}));
    };




    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchSeasonContractStats => [

        {    field: 'more',
            headerName: '',
            description: '',
            sortable: true,
            width: 60,
            hide: false,
            renderCell: (params) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <StatsMenu row={params.row}  />
                </div>
            )
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'seriesTitle',
            headerName: 'Series Title',
            description: '',
            sortable: true,
            editable: true,
            hide: true,
            // editable: true,
            width: 300,
        },
        {
            field: 'seriesId',
            headerName: 'Series ID',
            description: '',
            sortable: false,
            editable: false,
            hide: true,
            width: 80,
        },
        {
            field: 'seasonNumber',
            headerName: 'Season #',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 80,
        },
        {
            field: 'seasonName',
            headerName: 'Season Name',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 200,
        },
        {
            field: 'seasonId',
            headerName: 'Season ID',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 80,
        },
        {
            field: 'episodeCount',
            headerName: 'Episodes',
            headerAlign: 'center',
            width: 100,
            renderCell: (seasonContractStats) => {
                const count = seasonContractStats.row.episodeCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of episodes with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'guildCount',
            headerName: 'Guilds',
            width: 100,
            headerAlign: 'center',
            renderCell: (seasonContractStats) => {
                const count = seasonContractStats.row.guildCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'guilds',
            headerName: 'Guilds',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 300,
        },
        {
            field: 'approvedCount',
            headerName: 'Approved',
            width: 100,
            headerAlign: 'center',
            renderCell: (seasonContractStats) => {
                const count = seasonContractStats.row.approvedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of approved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'unapprovedCount',
            headerName: 'Unapproved',
            width: 100,
            headerAlign: 'center',
            renderCell: (seasonContractStats) => {
                const count = seasonContractStats.row.unapprovedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of unapproved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                // backgroundColor: "rgb(30,144,255)",
                                backgroundColor: "warning.main",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            { selectorGridDisplay === "SeasonFullScreen" && <Box sx={{height: 70, pt: 1, pl: 3}}><h3>Season Contract Statistics</h3></Box>}
            { selectorGridDisplay !== "SeasonFullScreen" && <Box sx={{height: 20, pt: 1, pl: 3}}/>}
            {gridVisible && <DataGrid
                style={{cursor: 'pointer'}}
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"SeasonContractStats"}
                rows={seasonContractStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchSeasonContractStats)}
                onRowClick = {(seasonContractStats)=>handleClickedRow(seasonContractStats.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                // I just added back in rowKey from the AmigosCode example, which should define seriesContractStat and seriesContractStat.id
                // this is needed for identifying which seriesContractStat to delete or edit
                rowKey={seriesContractStat => seriesContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
            {/*<div>*/}
            {/*</div>*/}
        </div>
    );

    // ****************** END RETURN ****************************

}

